import { useState, useEffect, useCallback } from 'react'

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'dracula'
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem('theme', theme)
    window.dispatchEvent(new Event('themeChange'))
  }, [theme])

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = localStorage.getItem('theme') || 'dracula'
      setTheme(newTheme)
    }

    window.addEventListener('themeChange', handleThemeChange)
    window.addEventListener('storage', handleThemeChange)

    return () => {
      window.removeEventListener('themeChange', handleThemeChange)
      window.removeEventListener('storage', handleThemeChange)
    }
  }, [])

  const toggleTheme = useCallback(() => {
    setTheme(prevTheme => prevTheme === 'dracula' ? 'light' : 'dracula')
  }, [])

  return { theme, setTheme, toggleTheme }
}
